// E-Ticaret › Ana Sayfa (Ana Sayfa Modül Yönetimi) kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.homePage';

export const ecommerceHomePageGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Ana sayfa nasıl düzenlenir?'),
  intro: t(`${G}.intro`, 'Web sitenizin ana sayfasında görünecek ürün modüllerini, marka akışını ve tanıtım kısımlarını buradan yönetirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.general`, 'Genel Ayarlar'),
    t(`${G}.nav.sections`, 'Sayfada Gösterilecek Kısımlar'),
    t(`${G}.nav.modules`, 'Modül sekmeleri'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler ve + düğmesi'),
    body: t(`${G}.regions.body`, 'Seçili sekmenin ayarları'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Genel ayarları seçin'),
      text: t(`${G}.s1.text`, '"Genel Ayarlar" sekmesindeki "Ana Sayfa Modül Stili" ile ana sayfadaki ürün ve kategori listelerinin görünümünü seçin: Modül 1 (Statik Görünüm) veya Modül 2 (Animasyonlu Görünüm).'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s2.title`, '2. Yeni modül ekleyin ve sıralayın'),
      text: t(`${G}.s2.text`, 'Yeni modül eklemek için sekmelerin sağındaki "+" düğmesini kullanın. Açılan pencerede Sekme Adı (zorunlu, yalnız yönetim panelinde görünür), Bölüm Başlığı (isteğe bağlı, ana sayfada görünür) ve modül şablonunu seçin. Her modül farklı ürün ve kategorileri gösterebilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Klasik (manuel ürün): ürünleri tek tek seçersiniz.'),
        t(`${G}.s2.tip2`, "Kategori ürün kartı (3'lü): kategori seçersiniz; vitrinde her kategorinin ilk 3 ürünü ve Tümü düğmesi görünür."),
        t(`${G}.s2.tip3`, 'Marka akışı: üründen bağımsızdır; markalar tam sayfa genişliğinde yavaşça sağdan sola kayar.'),
        t(`${G}.s2.tip4`, 'Modüllerin ana sayfadaki sırasını değiştirmek için sekmeleri sürükleyip bırakın; yeni sıra hemen kaydedilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Modülü ayarlayın'),
      text: t(`${G}.s3.text`, 'Bir modül sekmesine tıklayınca ayarları açılır. "Bu Modülü Ana Sayfada Göster" kapalıysa modül sitede görünmez. Modül Yatay Konum (Sol / Orta / Sağ) ve Modül Üst Boşluk ile yerleşimini, kalem simgesiyle adını değiştirirsiniz. Yaptığınız değişiklikler ayrıca bir düğmeye basmadan kaydedilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Modülü silmek için kırmızı çöp kutusu simgesini kullanın. Silme geri alınamaz; modülün tüm ayarları ve seçilen ürünleri kalıcı olarak silinir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Ürün kaynağını ve düzeni seçin'),
      text: t(`${G}.s4.text`, '"Ürün Gösterimi" bölümündeki "İçerik kaynağı" ile "Ürün seç" (ürünleri tek tek seçersiniz) veya "Kategoriye göre (ilk 3 ürün)" seçeneğinden birini işaretleyin. Kategoriye göre seçimde her kategori için vitrinde ilk 3 ürün kartı ve Tümü düğmesi gösterilir; Tümü, katalogda yalnız o kategoriyi açar.'),
      tips: [
        t(`${G}.s4.tip1`, '"Modül Görseli" bölümündeki "Ürün Yerleşim Ayarları" (Satır Sayısı / Sütun Sayısı), ürün ve kategori kartlarının ızgara görünümünü belirler. Modül resmi olmasa da ürün ızgarası bu ayara göre çizilir.'),
        t(`${G}.s4.tip2`, 'En fazla 2 satır × 6 sütun = 12 ürün gösterilebilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Marka akışı modülünü ayarlayın'),
      text: t(`${G}.s5.text`, 'Marka akışı modülünde ürün seçilmez. Markalar tam sayfa genişliğinde, sağdan sola yavaş kayarak akar. Arka plan rengi, başlık, alt başlık ve yazı stillerini bu modülün ayarlarından yaparsınız.'),
    },
    {
      region: 'tabs',
      title: t(`${G}.s6.title`, '6. Sayfada gösterilecek kısımları ekleyin'),
      text: t(`${G}.s6.text`, '"Sayfada Gösterilecek Kısımlar" sekmesinde bir şablon seçerek Hakkımızda, hizmetler, ürünler, referanslar ve iletişim özeti gibi kısımları ana sayfaya eklersiniz; her kısım ana sayfada kendi konumunda görünür. "Modern hero kullan" açıkken vitrinde slider yerine bu giriş alanı gösterilir.'),
      tips: [
        t(`${G}.s6.tip1`, 'Güven şeridi bu sayfada değil, Slider sekmesinin altındadır.'),
        t(`${G}.s6.tip2`, 'Başlıktaki (i) bu rehberi yeniden açar.'),
      ],
    },
  ],
});
